import { Box, SxProps, Theme, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { PortStatus } from '../../types/models'

export type StatusLightProps = {
  status: PortStatus
  sx?: SxProps<Theme>
}

/**
 * Display a green or red dot.
 */
export const StatusLight = (props: StatusLightProps): JSX.Element => {

  const { status, sx } = props
  const theme = useTheme()
  const { t } = useTranslation()

  let color

  switch (status) {
    case 'unknown':
      color = 'white'
      break
    case 'warning':
      color = 'magenta'
      break
    case 'success':
    case 'error':
      color = theme.palette[status].light
      break
    case 'ok':
      color = 'yellow'
      break
    case 'none':
      color = 'transparent'
      break
  }

  return (
    <Box title={status === 'none' ? undefined : t(`Status-${status}`)} sx={{
      mx: 'auto',
      backgroundColor: color,
      width: '0.5rem',
      height: '0.5rem',
      borderRadius: '2px',
      ...sx
    }}/>
  )
}
